module.exports = __webpack_public_path__ + "media/images/mymatrimony_logo_2-2c045bf0c00563df7c5b58935623db6f.png";